import { getIDToken } from "../utils/utils";
import * as config from "../config.js";
import { addChatSession } from "./agents";

export const SET_ACTIVE_CHAT_SESSION = "SET_ACTIVE_CHAT_SESSION";
export const SET_ACTIVE_CHAT_ID = "SET_ACTIVE_CHAT_ID";
export const SET_ACTIVE_CHAT_USAGE = "SET_ACTIVE_CHAT_USAGE";
export const ADD_CHAT_MESSAGE = "ADD_CHAT_MESSAGE";
export const ADD_CHAT_RESPONSE = "ADD_CHAT_RESPONSE";
export const SENDING_CHAT_MESSAGE = "SENDING_CHAT_MESSAGE";
export const CLEAR_CHAT_SESSION = "CLEAR_CHAT_SESSION";
export const DELETE_CHAT_MESSAGE = "DELETE_CHAT_MESSAGE";

export const clearChatSession = () => {
  return {
    type: CLEAR_CHAT_SESSION,
  };
};

export const startChatSession = (agent_id, inference_workflow_id = null) => {
  return (dispatch) => {
    dispatch({
      type: SENDING_CHAT_MESSAGE,
      sending: true,
    });

    fetch(`${config.REST_SERVER_URL}/admin/chat/start/${agent_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
      body: JSON.stringify({
        inference_workflow_id: inference_workflow_id,
      }),
    })
      .then((response) => response.json())
      .then((chatSession) => {
        if (chatSession.id) {
          dispatch(addChatSession(chatSession));
          dispatch({
            type: SET_ACTIVE_CHAT_SESSION,
            chatSession: chatSession,
          });
        }
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      })
      .finally(() => {
        dispatch({
          type: SENDING_CHAT_MESSAGE,
          sending: false,
        });
      });
  };
};

export const loadChatSession = (chat_session_id) => {
  return (dispatch) => {
    fetch(`${config.REST_SERVER_URL}/admin/chat/session/${chat_session_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then((chatSession) => {
        console.log("DATA: ", chatSession);
        if (chatSession.id) {
          dispatch({
            type: SET_ACTIVE_CHAT_SESSION,
            chatSession: chatSession,
          });
        }
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      });
  };
};

export const sendChatMessage = (
  message,
  chat_session_id,
  skip_user_message = false
) => {
  console.log("SEND MESSAGE: ", message, chat_session_id);
  return async (dispatch) => {
    dispatch({
      type: SENDING_CHAT_MESSAGE,
      sending: true,
    });

    if (!skip_user_message) {
      dispatch({
        type: ADD_CHAT_MESSAGE,
        message: {
          message: message,
          message_type: "user",
        },
      });
    }

    fetch(`${config.REST_SERVER_URL}/admin/chat/message/${chat_session_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
      body: JSON.stringify({
        message: message,
        skip_user_message: skip_user_message,
      }),
    })
      .then((response) => response.json())
      .then((chatResponse) => {
        console.log("CHAT RESPONSE: ", chatResponse);
        dispatch({
          type: ADD_CHAT_RESPONSE,
          chatResponse: chatResponse,
        });

        // update the session
        dispatch(loadChatSession(chat_session_id));
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      })
      .finally(() => {
        dispatch({
          type: SENDING_CHAT_MESSAGE,
          sending: false,
        });
      });
  };
};

export const sendQuizMessage = (
  activeQuiz,
  activeQuestion,
  message,
  chat_session_id
) => {
  return async (dispatch) => {
    dispatch({
      type: SENDING_CHAT_MESSAGE,
      sending: true,
    });

    dispatch({
      type: ADD_CHAT_MESSAGE,
      message: {
        message: message,
        message_type: "user",
      },
    });

    fetch(`${config.REST_SERVER_URL}/admin/chat/quiz/${chat_session_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
      body: JSON.stringify({
        quiz: activeQuiz,
        question: activeQuestion,
        message: message,
      }),
    })
      .then((response) => response.json())
      .then((chatResponse) => {
        console.log("CHAT RESPONSE: ", chatResponse);
        dispatch({
          type: ADD_CHAT_RESPONSE,
          chatResponse: chatResponse,
        });
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      })
      .finally(() => {
        dispatch({
          type: SENDING_CHAT_MESSAGE,
          sending: false,
        });
      });
  };
};

export const getChatSessionUsage = (chat_session_id) => {
  return (dispatch) => {
    fetch(`${config.REST_SERVER_URL}/admin/chat/usage/${chat_session_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then((usage) => {
        console.log("DATA: ", usage);
        if (usage) {
          dispatch({
            type: SET_ACTIVE_CHAT_USAGE,
            usage: usage,
          });
        }
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      });
  };
};

export const saveChatSessionStatus = (chat_session_id, status) => {
  return (dispatch) => {
    fetch(`${config.REST_SERVER_URL}/admin/chat/status/${chat_session_id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
      body: JSON.stringify({
        status: status,
      }),
    })
      .then((response) => response.json())
      .then((chat_session) => {
        dispatch({
          type: SET_ACTIVE_CHAT_SESSION,
          chatSession: chat_session,
        });
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      });
  };
};

export const deleteChatMessage = (chat_session_id, message_id) => {
  console.log("!!! DELETE CHAT MESSAGE: ", chat_session_id, message_id);
  return (dispatch) => {
    dispatch({
      type: DELETE_CHAT_MESSAGE,
      message_id: message_id,
    });

    fetch(
      `${config.REST_SERVER_URL}/admin/chat/message/${chat_session_id}/${message_id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": getIDToken(),
        },
      }
    )
      .then((response) => response.json())
      .then(() => {
        //
        // update the session
        dispatch(loadChatSession(chat_session_id));
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      });
  };
};
